export const state = () => ({
    books: [],
    selectedBook: [],
});
